import { useContext } from 'react'
import { AuthContext } from 'react-oauth2-code-pkce'

export const useAuth = () => {
  const authContext = useContext(AuthContext)

  const securedFetch = async (url, options = {}) => {
    const headers = await getAuthHeaders()
    return fetch(url, {
      ...options,
      headers: { ...options.headers, ...headers }
    })
  }

  const getAuthHeaders = async () => ({
    Authorization: `Bearer ${authContext.token}`
  })

  return {
    ...authContext,
    getAuthHeaders,
    loggedIn: !!authContext.token,
    securedFetch
  }
}
